module.exports = __webpack_public_path__ + "static/media/photo.cabfce3f.jpg";